





































import Vue from 'vue'
import { mapGetters } from 'vuex'

import { PaymentCalculatorService } from '../services/PaymentCalculatorService'
 
export default Vue.extend({
  props: ['price'],
  data () {
    return {
      frequency: 'Weekly',
      termType: 'Lease',
      termObj: {} as any,
    }
  },
  computed: {
    ...mapGetters({
      rate: 'terms/rate',
      term: 'terms/term',
      financeOptions: 'terms/financeOptions',
      leaseOptions: 'terms/leaseOptions',
      modelId: 'models/currentModelId',
      trim: 'trims/currentTrim',
    }),
    options() : object[] {
      return this.termType === 'Lease' ? this.leaseOptions : this.financeOptions
    },
    terms(): number[] {
      const terms : number[] = []
      if(this.options) {
        this.options.forEach((option: any) => {
          terms.push(option.term)
        })
        return terms
      }
      else {
        return []
      }
    },
    paymentPeriods() : number {
      return PaymentCalculatorService.getPaymentPeriods(this.frequency)
    },
    payment() : number {
      return PaymentCalculatorService.calculatePayment(this.rate, this.price, this.paymentPeriods, this.term)
    }
  },
  mounted() {
    this.frequency = this.$store.getters['terms/currentFrequency']
    this.termObj.rate = this.$store.getters['terms/rate']
    this.termObj.term = this.$store.getters['terms/term']
  },
  watch: {
    frequency(newValue: string) {
      this.$store.commit('terms/updateFrequency', newValue)
    },
    termType(newTerm: string) {
      this.$store.commit('terms/updateTermType', newTerm)
    },
    termObj(newValue: { term: number, rate: number }) {
      if (this.termType === 'Lease') {
        this.$store.commit('terms/updateLeaseRate', newValue.rate)
      } else {
        this.$store.commit('terms/updateFinanceRate', newValue.rate)
      }

      this.$store.commit('terms/updateTerm', newValue.term)
    },
  }
})
